import React from 'react';

interface RedditIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const RedditIcon: React.FC<RedditIconProps> = ({ className, ...props }) => {
  return (
    <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden
  >
    <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.517A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.25.687 0 1.248-.563 1.25-1.25 0-.688-.563-1.25-1.25-1.25zm5.5 0c-.687 0-1.248.563-1.248 1.25 0 .687.561 1.248 1.25 1.25.687 0 1.248-.563 1.25-1.25 0-.688-.563-1.25-1.25-1.25zM12 15.5c-1.094 0-2.094.254-2.844.75-.15.1-.25.25-.25.416 0 .216.184.384.4.384h4.688c.216 0 .4-.168.4-.384a.43.43 0 0 0-.25-.416c-.75-.496-1.75-.75-2.844-.75z" />
  </svg>
  );
};
